<template>
  <div>
    <!-- <pre>{{modulePermission}}</pre> -->
    <!-- {{checkSendPermission()}}
            {{schoolAdmin}} -->
    <!-- {{this.$route.query.related_id}} -->
    <vs-card class="email-card">
      <div
        class="text-right mb-2"
        v-if="selected.length > 1"
      >
        <div class="bulk_holder">
          <a @click="showPopUpBool = !showPopUpBool">Bulk Delete</a>
        </div>
      </div>

      <div class="flex flex-wrap justify-between items-center">
        <div class="md:w-1/2 w-full p-1">
          <vs-input
            placeholder="Search"
            class="w-full"
            v-model="search"
            @keyup="searchFun"
            style="width: 100%"
          />
        </div>
        <vs-button
          @click="newComposeEmail = true"
          type="filled"
          >Compose Email</vs-button
        >
      </div>
      <!-- {{selected}} -->
      <vs-tabs v-model="tabIndex">
        <vs-tab
          :label="`Inbox ${EmailInboxData_new_message_count}`"
          icon-pack="feather"
          icon="icon-inbox"
        >
          <ag-grid-vue
            ref="agGridTable"
            :components="components"
            :gridOptions="inboxGridOptions"
            class="ag-theme-material w-100 my-4 ag-grid-table"
            @row-selected="CellvalueSelectDeselect"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            :rowData="rowData"
            rowSelection="multiple"
            colResizeDefault="true"
            :animateRows="true"
            :floatingFilter="false"
            :pagination="true"
            :suppressPaginationPanel="true"
            :enableRtl="$vs.rtl"
            @cell-clicked="cellSingleClicked
            "
            :style="{ minHeight: query_page.inbox.limit * 48 + 75 + 'px' }"
            :paginationPageSize="paginationPageSize('inbox')"
            @grid-ready="onGridReady"
            @sortChanged="sortFun"
          >
          </ag-grid-vue>
          <vs-row class="mt-2" vs-type="flex" vs-justify="space-between">
            <vs-col
              vs-w="4"
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
            >
              <ItemsPerTableDropdown
                tableName="email_inbox"
                @change="(pageLimit) => (inboxPageLimitSet = pageLimit)"
              />
            </vs-col>
          </vs-row>
          <pagination
            :meta="query_page.inbox"
            @page-change="handlePageChange('inbox', $event)"
            class="cstm_pagination"
            style="float: right"
          />
        </vs-tab>

        <vs-tab :label="`Sent`" icon-pack="feather" icon="icon-send">
          <ag-grid-vue
            ref="agGridTable"
            :components="components"
            :gridOptions="sentGridOptions"
            class="ag-theme-material w-100 my-4 ag-grid-table"
            @row-selected="CellvalueSelectDeselect"
            :columnDefs="columnDefsSent"
            :defaultColDef="defaultColDefSent"
            :rowData="rowDataSent"
            rowSelection="multiple"
            colResizeDefault="true"
            :animateRows="true"
            :floatingFilter="false"
            :pagination="true"
            :suppressPaginationPanel="true"
            :enableRtl="$vs.rtl"
            @cell-clicked="cellSingleClicked"
            :style="{ minHeight: query_page.sent.limit * 48 + 75 + 'px' }"
            :paginationPageSize="paginationPageSize('sent')"
            @grid-ready="onGridReady"
            @sortChanged="sortFun"
          >
          </ag-grid-vue>
          <vs-row class="mt-2" vs-type="flex" vs-justify="space-between">
            <vs-col
              vs-w="4"
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
            >
              <ItemsPerTableDropdown
                tableName="email_sent"
                @change="(pageLimit) => (sentPageLimitSet = pageLimit)"
              />
            </vs-col>
          </vs-row>
          <pagination
            :meta="query_page.sent"
            @page-change="handlePageChange('sent', $event)"
            class="cstm_pagination"
            style="float: right"
          />
        </vs-tab>
        <vs-tab label="Draft" icon-pack="feather" icon="icon-file">
          <ag-grid-vue
            ref="agGridTable"
            :components="components"
            :gridOptions="draftGridOptions"
            class="ag-theme-material w-100 my-4 ag-grid-table"
            @row-selected="CellvalueSelectDeselect"
            :columnDefs="columnDefsDraft"
            :defaultColDef="defaultColDefDraft"
            :rowData="rowDataDraft"
            rowSelection="multiple"
            colResizeDefault="true"
            :animateRows="true"
            :floatingFilter="false"
            :pagination="true"
            :suppressPaginationPanel="true"
            :enableRtl="$vs.rtl"
            @cell-clicked="cellSingleClicked"
            :style="{ minHeight: query_page.draft.limit * 48 + 75 + 'px' }"
            :paginationPageSize="paginationPageSize('draft')"
            @grid-ready="onGridReady"
            @sortChanged="sortFun"
          >
          </ag-grid-vue>
          <vs-row class="mt-2" vs-type="flex" vs-justify="space-between">
            <vs-col
              vs-w="4"
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
            >
              <ItemsPerTableDropdown
                tableName="email_draft"
                @change="(pageLimit) => (draftPageLimitSet = pageLimit)"
              />
            </vs-col>
          </vs-row>
          <pagination
            :meta="query_page.draft"
            @page-change="handlePageChange('draft', $event)"
            class="cstm_pagination"
            style="float: right"
          />
        </vs-tab>
      </vs-tabs>
      <!-- <vs-button
        class="compose-btn"
        @click="composeEmail"
        type="filled"
        v-if="checkSendPermission()"
        >Compose Email</vs-button
      > -->
      
      <!-- <vs-button class="compose-btn" @click="composeEmail" type="filled"
        >Compose Email</vs-button
      > -->
      <div
        class="full-cstm-sidebar mt-107 z-1000"
        :class="{ open: emailSidebar }"
      >
        <div class="mt-6 flex items-center justify-between px-6">
          <h4>Compose Email</h4>
          <feather-icon
            icon="XIcon"
            class="cursor-pointer"
            @click="handlcreateSidebar"
          />
        </div>
        <vs-divider class="mb-0" />
        <div class="p-6 pt-2 sidebar-scrollable-form">
          <br />
          <h5 class="block mb-2">Recipients</h5>
          <ul class="flex">
            <li>
              <vs-checkbox v-model="user_recipient">Staffs </vs-checkbox>
            </li>

            <li>
              <vs-checkbox v-model="client_recipient">Students </vs-checkbox>
            </li>

            <li>
              <vs-checkbox v-model="custom_user_recipient">Custom </vs-checkbox>
            </li>
          </ul>

          <vs-divider />

          <div class="mb-4">
            <label>Platform Modules</label>
            <!-- {{selectedPlatformModule}} -->
            <v-select
              name="module_name"
              :options="platformModuleList"
              label="module_name"
              :reduce="(option) => option.platform_modules_id"
              v-model="selectedPlatformModule"
              :clearable="false"
              @input="getRelatedRecords()"
            />
          </div>
          <!-- <div class="mb-4"> // commentend for shankhadeepa's call with juli
            <label>Module Action</label>
            <v-select
              name="record_name"
              :options="relatedRecordList"
              label="name"
              :reduce="(option) => option.id"
              v-model="selectedRelatedRecords"
              :clearable="false"
            >
              <template v-slot:selected-option="relatedRecordList">
                <img
                  v-if="relatedRecordList.picture"
                  class="person-img rounded-full"
                  :src="relatedRecordList.picture"
                />
                <img
                  v-else
                  class="person-img rounded-full"
                  src="@/assets/images/pages/user-circle-solid.svg"
                />
                {{ relatedRecordList.name }}
              </template>
              <template v-slot:option="relatedRecordList">
                <img
                  v-if="relatedRecordList.picture"
                  class="person-img rounded-full"
                  :src="relatedRecordList.picture"
                />
                <img
                  v-else
                  class="person-img rounded-full"
                  src="@/assets/images/pages/user-circle-solid.svg"
                />
                {{ relatedRecordList.name }}
              </template>
            </v-select>
          </div> -->

          <vs-divider />

          <div class="to-recipient">
            <h6><b>To : </b></h6>
            <br />
            <div class="user_recipient mb-4" v-if="user_recipient">
              <label>Staffs</label>

              <v-select
                :getOptionLabel="
                  (item) => `${item.first_name} ${item.last_name}`
                "
                class="w-full"
                :reduce="(option) => option.users_id"
                :options="recipient_user_list"
                v-model="selected_user_recipient"
                :clearable="false"
                data-vv-name="user_list"
                name="user_list"
                multiple
              >
                <template v-slot:selected-option="recipient_user_list">
                  <img
                    v-if="recipient_user_list.picture"
                    class="person-img rounded-full"
                    :src="recipient_user_list.picture"
                  />
                  <img
                    v-else
                    class="person-img rounded-full"
                    src="@/assets/images/pages/user-circle-solid.svg"
                  />
                  {{ recipient_user_list.first_name }}
                  {{ recipient_user_list.last_name }}
                </template>
                <template v-slot:option="recipient_user_list">
                  <img
                    v-if="recipient_user_list.picture"
                    class="person-img rounded-full"
                    :src="recipient_user_list.picture"
                  />
                  <img
                    v-else
                    class="person-img rounded-full"
                    src="@/assets/images/pages/user-circle-solid.svg"
                  />
                  {{ recipient_user_list.first_name }}
                  {{ recipient_user_list.last_name }}
                </template>
              </v-select>
              <!-- {{recipient_user_list}} -->
              <!-- {{selected_user_recipient}} -->
            </div>

            <div class="client_recipient mb-4" v-if="client_recipient">
              <label>Students </label>

              <v-select
                :getOptionLabel="
                  (item) => `${item.first_name} ${item.last_name}`
                "
                class="w-full"
                :reduce="(option) => option.client_users_id"
                :options="recipient_client_list"
                v-model="selected_client_recipient"
                :clearable="false"
                data-vv-name="user_list"
                name="user_list"
                multiple
              >
                <template v-slot:selected-option="recipient_client_list">
                  <img
                    v-if="recipient_client_list.picture"
                    class="person-img rounded-full"
                    :src="recipient_client_list.picture"
                  />
                  <img
                    v-else
                    class="person-img rounded-full"
                    src="@/assets/images/pages/user-circle-solid.svg"
                  />
                  {{ recipient_client_list.first_name }}
                  {{ recipient_client_list.last_name }}
                </template>
                <template v-slot:option="recipient_client_list">
                  <img
                    v-if="recipient_client_list.picture"
                    class="person-img rounded-full"
                    :src="recipient_client_list.picture"
                  />
                  <img
                    v-else
                    class="person-img rounded-full"
                    src="@/assets/images/pages/user-circle-solid.svg"
                  />
                  {{ recipient_client_list.first_name }}
                  {{ recipient_client_list.last_name }}
                </template>
              </v-select>
              <!-- {{recipient_client_list}} -->
              <!-- {{selected_client_recipient}} -->
            </div>

            <div class="client_recipient mb-4" v-if="custom_user_recipient">
              <vs-input
                v-model="external_users"
                class="w-full"
                label="Custom"
                placeholder=""
                @keypress="preventCommaKey"
              />
              <!-- {{external_users}} -->
            </div>
          </div>

          <vs-button
            v-if="!EmailHasCC"
            class="block ml-auto"
            @click="EmailHasCC = !EmailHasCC"
            type="filled"
            size="medium"
            >Add CC</vs-button
          >

          <vs-button
            v-if="EmailHasCC"
            class="block ml-auto"
            @click="removeCC()"
            type="border"
            color="danger"
            size="medium"
            >Remove CC</vs-button
          >

          <div class="cc-recipient" v-if="EmailHasCC">
            <h6><b>CC : </b></h6>
            <br />
            <div class="user_recipient mb-4" v-if="user_recipient">
              <label class="vs-input--label">Staffs</label>
              <v-select
                class="w-full"
                :getOptionLabel="
                  (item) => `${item.first_name} ${item.last_name}`
                "
                :reduce="(option) => option.to_user"
                :options="recipient_user_list_cc"
                v-model="selected_user_recipient_cc"
                :clearable="false"
                data-vv-name="user_list"
                name="user_list"
                multiple
              ></v-select>
              <!-- {{recipient_user_list_cc}} -->
              <!-- {{selected_user_recipient_cc}} -->
            </div>

            <div class="client_recipient mb-4" v-if="client_recipient">
              <label class="vs-input--label">Students </label>
              <v-select
                class="w-full"
                :getOptionLabel="
                  (item) => `${item.first_name} ${item.last_name}`
                "
                :reduce="(option) => option.to_user"
                :options="recipient_client_list_cc"
                v-model="selected_client_recipient_cc"
                :clearable="false"
                data-vv-name="user_list"
                name="user_list"
                multiple
              ></v-select>
              <!-- {{recipient_client_list_cc}} -->
              <!-- {{selected_client_recipient_cc}} -->
            </div>

            <div class="client_recipient mb-4" v-if="custom_user_recipient">
              <vs-input
                v-model="external_users_cc"
                class="w-full"
                label="Custom"
                placeholder=""
              />
              <!-- {{external_users_cc}} -->
            </div>
          </div>

          <vs-divider />

          <vs-textarea
            class="my-2"
            counter="255"
            label="Write a Subject Line"
            v-model="emailSubject"
          />

          <div class="mt-8">
            <!-- {{emailBody}} -->
            <editor
              :api-key="tinyMceApi"
              output-format="html"
              v-model="emailBody"
              :init="initTinyMce"
            />
          </div>

          <div class="email-action-btns">
            <vs-tooltip
              text="Send"
              style="
                display: inline-block;
                margin-top: 10px;
                margin-right: 10px;
              "
            >
              <vs-button
                class="mt-4 compose-btns"
                @click="sendSaveEmail('send')"
                radius
                color="primary"
                type="filled"
                icon="send"
                size="large"
                style="margin-top: 0px !important; margin-right: 0px !important"
              ></vs-button>
            </vs-tooltip>

            <vs-tooltip
              text="Save as draft"
              style="
                display: inline-block;
                margin-top: 10px;
                margin-right: 10px;
              "
            >
              <vs-button
                class="mt-4 compose-btns"
                @click="sendSaveEmail('save')"
                radius
                color="primary"
                type="filled"
                icon="save"
                size="large"
                style="margin-top: 0px !important; margin-right: 0px !important"
              ></vs-button>
            </vs-tooltip>
          </div>

          <vs-divider />
          <label>Codes with Description</label>
          <small>(Click to append)</small>
          <vs-divider />

          <div class="flex flex-wrap">
            <div
              class="outer-field-cstm-badge sm:w-1/2 w-full"
              style="padding: 0 5px"
              :key="index"
              v-for="(item, index) in fieldCodes"
            >
              <div class="field-cstm-badge">
                <a @click="appendCodeToTemplate(item.field_code)">{{
                  item.field_code
                }}</a>
                <a class="info"><span class="material-icons">info</span></a>
                <p class="description">{{ item.field_description }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-overlay"></div>
    </vs-card>
    <div v-if="isBrowseContent">
      <vs-popup
        fullscreen
        title="Browse Item"
        :active.sync="isBrowseContent"
        class="childImportPopUp"
      >
        <import-browse-files-model
          v-if="isBrowseContent"
          :file_repository_id="file_repository_id"
          @getImportFile="getImportFile"
        ></import-browse-files-model>
        <!-- <div slot="footer">jfjfjf</div> -->
      </vs-popup>
    </div>
    <vs-popup
      classContent="popup-example"
      title="Please Confirm"
      :active.sync="showPopUpBool"
    >
      <h4>Are you sure to delete this emails?</h4>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button color="danger" class="mr-2" @click="deleteAllSelectedEmail">Confirm</vs-button>
        <vs-button type="border" color="danger" @click="showPopUpBool = false"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>
    <!-- new compose email modal -->
    <div v-if="newComposeEmail">
      <ComposeEmailPopup :newComposeEmail="newComposeEmail" @closeComposeEmailPopup="closeComposeEmailPopup" @closeModalUpdate="closeModalUpdate" />
    </div>
    <div v-if="draftModal">
      <DraftEmailPopup :draftModal="draftModal" :draftDetails="draftDetails" @closeDraftEmailPopup="closeDraftEmailPopup" @closeModalUpdate="closeModalUpdate" />
    </div>

  </div>
</template>

<script>
import DraftEmailPopup from '@/views/pages/email/draftCompose.vue'
import ComposeEmailPopup from '@/views/pages/email/composeEmailPopup.vue'
import Vue from 'vue'
import { AgGridVue } from 'ag-grid-vue'
import Actionrenderer from './ActionRender.vue'
import DraftAction from './DraftAction.vue'
import deleteSentEmailComponent from './deleteSentEmail.vue'
import RecipientsComponent from './RecipientsComponent.vue'
import SubjectRender from './subjectRender.vue'
import ImageRender from './imageRender.vue'
import SenderCell from './SenderCell.vue'
import Bell from './Bell'
import Editor from '@tinymce/tinymce-vue'
import vSelect from 'vue-select'
import { contentFileUpload } from '@/api/course-builderapi'
import Pagination from '@/components/common/pagination'
import ImportBrowseFilesModel from '@/components/common/ImportBrowseFilesModel.vue'
import { GoogleAuthorization } from '@/mixins/common/GoogleAuthorization.js'
import { getRepositoryDetails } from '@/api/message'
import { getUploadedFilesId } from '@/api/assignment-question'

import {
  fetch_user_list as fetch_user_client_list,
  sendSaveEmail,
  getEmailInboxList,
  getEmailSentList,
  getEmailDraftList,
  deleteInboxEmail,
  deleteSentEmail,
  deleteDraftEmail,
  fetch_user_general_list
} from '@/api/communication'

import { getFilteredPlatformModules, getRelatedRecords } from '@/api/email'

import { PermissionMiddleware } from '../../../mixins/middleware/PermissionMiddleware'

export default {
  name: 'Email',
  components: {
    Bell,
    editor: Editor,
    vSelect,
    Pagination,
    ImportBrowseFilesModel,
    AgGridVue,
    Actionrenderer,
    SubjectRender,
    ImageRender,
    SenderCell,
    RecipientsComponent,
    deleteSentEmailComponent,
    DraftAction,
    ComposeEmailPopup,
    DraftEmailPopup
  },
  mixins: [PermissionMiddleware, GoogleAuthorization],
  data () {
    return {
      showPopUpBool: false,
      draftDetails:null,
      newComposeEmail: false,
      draftModal: false,

      search: '',
      tabIndex: this.$route.hash == '#sent' ? 1 : (this.$route.hash == '#draft' ? 2 : 0) ,
      components: {
        Actionrenderer,
        RecipientsComponent
      },
      rowData: [],
      rowDataSent: [],
      rowDataDraft: [],
      gridApi: null,
      inboxGridOptions: {
        accentedSort: true
      },
      sentGridOptions: {
        accentedSort: true
      },
      draftGridOptions: {
        accentedSort: true
      },
      initTinyMce: {
        setup: (editor) => {
          editor.ui.registry.addIcon(
            'filesIcon',
            '<svg class="primary_svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-6.92-3.96L12.39 17 15 15.47 17.61 17l-.69-2.96 2.3-1.99-3.03-.26L15 9l-1.19 2.79-3.03.26z"/></svg>'
          )
          editor.ui.registry.addIcon(
            'gDriveIcon',
            '<svg class="font_18" enable-background="new 0 0 32 32" height="32px" id="Layer_1" version="1.0" viewBox="0 0 32 32" width="32px" xml:space="preserve"><g><polyline fill="#537ABD" points="31.868,21 9.868,21 4.868,30 26.556,30  "></polyline><polyline fill="#2EB672" points="10.962,2 -0.038,20 4.962,30 15.683,10.345  "></polyline><polyline fill="#FED14B" points="20.962,2 10.962,2 21.712,21 31.962,21 20.962,2  "></polyline></g></svg>'
          )
          editor.ui.registry.addButton('customInsertButton', {
            icon: 'filesIcon',
            tooltip: 'Insert Image from repo',
            onAction: () => {
              this.importModelRepo(editor)
            }
          })
          editor.ui.registry.addButton('gDrive', {
            icon: 'gDriveIcon',
            tooltip: 'Insert from GDrive',
            onAction: () => {
              this.gDrive(editor)
            }
          })
        },
        height: 300,
        menubar: true,
        branding: false,
        images_upload_url: this.image_url,
        automatic_uploads: true,
        images_upload_credentials: true,
        images_upload_handler: this.example_image_upload_handler,
        plugins: [
          'autolink lists link image charmap print preview anchor',
          'imagetools',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code help wordcount',
          'code lists fullscreen',
          'emoticons'
        ],
        menu: 'table',
        toolbar:
          'customInsertButton gDrive insertfile image link |undo redo | formatselect | bold italic backcolor | \          table alignleft aligncenter alignright alignjustify | \          bullist numlist outdent indent | removeformat | help'
      },
      defaultColDef: {
        suppressMenu: false,
        editable: true,
        sortable: true,
        resizable: true
        // autoHeight: true
      },
      defaultColDefDraft: {
        suppressMenu: false,
        editable: true,
        sortable: true,
        resizable: true
        // autoHeight: true
      },
      defaultColDefSent: {
        suppressMenu: false,
        editable: true,
        sortable: true,
        resizable: true
        // autoHeight: true
      },
      columnDefs: [],
      columnDefsSent: [],
      columnDefsDraft: [],
      file_repository_id: '',
      editorComponent: null,
      isBrowseContent: false,
      query_page: {
        inbox: {
          total: '',
          limit: 10,
          has_next: false,
          current_page: 1,
          next_page_url: null,
          previous_page_url: ''
        },
        sent: {
          total: '',
          limit: 10,
          has_next: false,
          current_page: 1,
          next_page_url: null,
          previous_page_url: ''
        },
        draft: {
          total: '',
          limit: 10,
          has_next: false,
          current_page: 1,
          next_page_url: null,
          previous_page_url: ''
        }
      },
      draft_other_ids: null,
      user_recipient: true,
      client_recipient: false,
      custom_user_recipient: false,
      custom_emails: false,
      user_recipient_cc: true,
      client_recipient_cc: false,
      custom_user_recipient_cc: false,
      custom_emails_cc: false,
      tinyMceApi: '',
      emailSubject: '',
      emailBody: '',
      EmailHasCC: false,
      image_url: '',
      textarea: '',
      from_user_type: '1',
      selected_user_recipient: [],
      selected_client_recipient: [],
      selected_user_recipient_cc: [],
      selected_client_recipient_cc: [],
      external_users: '',
      external_users_arr: [],
      external_users_cc: '',
      sendEmailToUsers: [],
      selected: [],
      log: [],
      emailSidebar: false,
      localContentValue: '',
      recipient_user_list: [],
      recipient_client_list: [],
      recipient_user_list_cc: [],
      recipient_client_list_cc: [],
      EmailInboxData: [],
      EmailSentData: [],
      EmailDraftData: [],
      recipient_type: false,
      EmailInboxData_new_message_count: '',
      showBtn: false,
      activeEditDraftId: null,
      platformModuleList: [],
      selectedPlatformModule: null,
      selectedRelatedRecords: null,
      relatedRecordList: [],
      fieldCodes: [],
      inboxPageLimitSet: null,
      draftPageLimitSet: null,
      sentPageLimitSet: null,
      sorting_obj: {
        field_type: '',
        attribute: '',
        direction: ''
      },
      sorting_obj_sent: {
        field_type: '',
        attribute: '',
        direction: ''
      },
      sorting_obj_draft: {
        field_type: '',
        attribute: '',
        direction: ''
      }
    }
  },
  created () {
    this.tinyMceApi = process.env.VUE_APP_TINYMCE_API
    const customer_id = localStorage.getItem('customer_id')
    const imageUploadUrl = process.env.VUE_APP_IMAGE_UPLOAD_URL
    this.image_url = `${imageUploadUrl}${customer_id}`
    const role_permission = localStorage.getItem('role_permission')
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Communication', 'email')
    }

    this.getPlatformModuleList()

    this.columnDefs = [
      {
        headerName: '',
        width: 60,
        field: 'isSelected',
        filter: false,
        sortable: false,
        checkboxSelection: (params) => {
          return true
        },
        headerCheckboxSelectionFilteredOnly: true,
        headerCheckboxSelection: true
      },
      {
        headerName: 'Sender',
        field: 'sender',
        filter: false,
        minWidth: 150,
        editable: false,
        sortable: false,
        cellRendererFramework: Vue.extend(SenderCell)
      },
      {
        headerName: 'Subject',
        field: 'subject',
        filter: false,
        minWidth: 150,
        editable: false,
        cellRendererFramework: Vue.extend(SubjectRender)
      },
      {
        headerName: 'Action',
        field: 'action',
        filter: false,
        minWidth: 100,
        maxWidth: 100,
        editable: false,
        sortable: false,
        cellRendererFramework: Vue.extend(Actionrenderer),
        filterParams: { delete: this.deleteInboxEmail }
      }
    ]

    this.columnDefsSent = [
      {
        headerName: '',
        width: 60,
        field: 'isSelected',
        filter: false,
        sortable: false,
        checkboxSelection: (params) => {
          return true
        },
        headerCheckboxSelectionFilteredOnly: true,
        headerCheckboxSelection: true
      },
      {
        headerName: 'Recipients',
        field: 'allExternalUsers',
        filter: false,
        minWidth: 150,
        editable: false,
        sortable: false,
        cellRendererFramework: Vue.extend(RecipientsComponent)
      },
      {
        headerName: 'Subject',
        field: 'subject',
        filter: false,
        minWidth: 150,
        editable: false,
        cellRendererFramework: Vue.extend(SubjectRender)
      },
      {
        headerName: 'Description',
        field: 'body',
        filter: false,
        minWidth: 150,
        editable: false,
        valueGetter: (param) => {
          return this.decodeHtml(this.getPlainText(param.data.body, param.data.subject))
        }
      },
      {
        headerName: 'Action',
        field: 'action',
        filter: false,
        minWidth: 100,
        maxWidth: 100,
        editable: false,
        sortable: false,
        cellRendererFramework: Vue.extend(deleteSentEmailComponent),
        filterParams: { deleteSentEmail: this.deleteSentEmail }
      }
    ]

    this.columnDefsDraft = [
      {
        headerName: '',
        width: 60,
        field: 'isSelected',
        filter: false,
        sortable: false,
        checkboxSelection: (params) => {
          return true
        },
        headerCheckboxSelectionFilteredOnly: true,
        headerCheckboxSelection: true
      },
      {
        headerName: 'Recipients',
        field: 'allRecipients',
        filter: false,
        minWidth: 150,
        editable: false,
        sortable: false,
        cellRendererFramework: Vue.extend(RecipientsComponent)
      },
      {
        headerName: 'Subject',
        field: 'subject',
        filter: false,
        minWidth: 150,
        editable: false,
        cellRendererFramework: Vue.extend(SubjectRender)
      },
      {
        headerName: 'Description',
        field: 'body',
        filter: false,
        minWidth: 150,
        editable: false,
        valueGetter: (param) => {
          return this.decodeHtml(this.getPlainText(param.data.body, param.data.subject))
        }
      },
      {
        headerName: 'Action',
        field: 'action',
        filter: false,
        minWidth: 100,
        maxWidth: 100,
        editable: false,
        sortable: false,
        cellRendererFramework: Vue.extend(DraftAction),
        filterParams: {
          openDraftEdit: this.openDraftEditPopup,
          deleteDraftEmail: this.deleteDraftEmail
        }
      }
    ]
  },
  methods: {
    openDraftEditPopup (data) {
      this.draftModal = true 
      this.draftDetails = data
    },
    closeModalUpdate (send_or_save) {
      this.newComposeEmail = false
      if (send_or_save === 'send') {
        this.getSentList()
      } else {
        this.getDraftList()
      }
      
    },
    closeComposeEmailPopup () {
      this.newComposeEmail = false
    },
    closeDraftEmailPopup () {
      this.draftModal = false
    },
    searchFun () {
      this.fetchListBySearch(this)
    },
    fetchListBySearch: _.debounce(async (vm) => {
      try {
        if (vm.tabIndex === 0) {
          vm.getInboxList()
        } else if (vm.tabIndex === 1) {
          vm.getSentList()
        } else if (vm.tabIndex === 2) {
          vm.getDraftList()
        }
      } catch (e) {
        console.log(e)
      }
    }, 1000),
    async sortFun () {
      try {
        let sortState = ''
        if (this.tabIndex === 0) {
          sortState = this.inboxGridOptions.api.getSortModel()
          if (!sortState.length > 0) {
            this.sorting_obj.field_type = ''
            this.sorting_obj.attribute = ''
            this.sorting_obj.direction = ''
          } else {
            this.sorting_obj.field_type = 'system'
            this.sorting_obj.attribute = sortState[0].colId
            this.sorting_obj.direction = sortState[0].sort
          }
          
          this.getInboxList()
        } else if (this.tabIndex === 1) {
          sortState = this.sentGridOptions.api.getSortModel()
          if (!sortState.length > 0) {
            this.sorting_obj_sent.field_type = ''
            this.sorting_obj_sent.attribute = ''
            this.sorting_obj_sent.direction = ''
          } else {
            this.sorting_obj_sent.field_type = 'system'
            this.sorting_obj_sent.attribute = sortState[0].colId
            this.sorting_obj_sent.direction = sortState[0].sort
          }
          this.getSentList()
        } else if (this.tabIndex === 2) {
          sortState = this.draftGridOptions.api.getSortModel()
          if (!sortState.length > 0) {
            this.sorting_obj_draft.field_type = ''
            this.sorting_obj_draft.attribute = ''
            this.sorting_obj_draft.direction = ''
          } else {
            this.sorting_obj_draft.field_type = 'system'
            this.sorting_obj_draft.attribute = sortState[0].colId
            this.sorting_obj_draft.direction = sortState[0].sort
          }
          this.getDraftList()
        }
      } catch (e) {
        //
      }
    },
    getSelectedRows () {
      const selectedNodes = this.gridApi.getSelectedNodes()
      const selectedData = selectedNodes.map((node) => node.data)
      //
      return selectedData
    },
    onGridReady () {
      if (this.tabIndex === 0) {
        this.inboxGridOptions.api.sizeColumnsToFit()
      } else if (this.tabIndex === 1) {
        this.sentGridOptions.api.sizeColumnsToFit()
      } else if (this.tabIndex === 2) {
        this.draftGridOptions.api.sizeColumnsToFit()
      }
    },
    cellSingleClicked (params) {
      const email_type = this.tabIndex === 0 ? 'inbox' : this.tabIndex === 1 ? 'sent' : 'draft'
      if (params.colDef.headerName !== 'Action') {
        if (email_type === 'inbox' || email_type === 'sent') {
          this.openEmailDetailsPage(email_type, params.data)
        } else {
          this.draftModal = true
          this.draftDetails = params.data
        }
      }

      
    },
    paginationPageSize (list_type) {
      if (list_type === 'inbox') {
        return this.inboxPageLimitSet
      } else if (list_type === 'sent') {
        return this.sentPageLimitSet
      } else if (list_type === 'draft') {
        return this.draftPageLimitSet
      }
    },
    CellvalueSelectDeselect () {
      if (this.tabIndex === 0) {
        this.gridApi = this.inboxGridOptions.api
      } else if (this.tabIndex === 1) {
        this.gridApi = this.sentGridOptions.api
      } else if (this.tabIndex === 2) {
        this.gridApi = this.draftGridOptions.api
      }

      const selectedNodes = this.gridApi.getSelectedNodes()
      //
      if (selectedNodes) {
        //
        const selecttedNode = this.gridApi.getSelectedNodes()
        this.selected = selecttedNode.map((node) => node.data)
      } else {
        this.selected = []
      }
    },
    async getPlatformModuleList () {
      try {
        const response = await getFilteredPlatformModules()
        this.platformModuleList = response.data.data.module_list
      } catch (e) {
        console.log(e)
      }
    },
    async getRelatedRecords () {
      try {
        const payload = {
          customer_id: localStorage.getItem('customer_id'),
          module_id: this.selectedPlatformModule
        }

        this.selectedRelatedRecords = null
        const response = await getRelatedRecords(payload)
        this.relatedRecordList = response.data.data.module_record_list
        this.fieldCodes = response.data.data.module_related_dynamic_field
      } catch (e) {
        console.log(e)
      }
    },
    async getRepositoryDetails () {
      const payload = {
        platform_module_id: '39'
      }
      const customer_id = localStorage.getItem('customer_id')
      const data = await getRepositoryDetails(customer_id, payload)
      //
      //
      this.file_repository_id = data.data.data[0].id
    },
    importModelRepo (editor) {
      this.editorComponent = editor
      this.isBrowseContent = true
    },
    gDrive (editor) {
      this.editorComponent = editor
      this.driveIconClicked()
    },
    getImportFile ({ file_id, fileInfo }) {
      fileInfo.forEach((eachFile) => {
        this.editorComponent.insertContent(
          `<img src="${eachFile.file_path}" width="auto" height="auto"/>`
        )
      })
      setTimeout(() => {
        this.isBrowseContent = false
        this.showSuccessMessage(
          'Success',
          'File Imported Successfully',
          'success'
        )
      }, 0)
    },
    async getUploadFiles (file_id_payload, type = 'system') {
      const res = await getUploadedFilesId(file_id_payload)

      const filesDriveInfo = res.data.data.files
      if (type === 'drive') {
        filesDriveInfo.forEach((eachFile) => {
          if (eachFile.file_type.split('/')[0] === 'image') {
            this.editorComponent.insertContent(
              `<img src="${eachFile.file_path}" width="200" height="200"/>`
            )
          } else if (eachFile.file_type.split('/')[0] === 'video') {
            this.editorComponent.insertContent(
              `<video width="200" height="300"<source src="${eachFile.file_path}"</video>`
            )
          } else if (eachFile.file_type.split('/')[0] === 'audio') {
            this.editorComponent.insertContent(
              `<img src="${eachFile.file_path}" width="200" height="200"/>`
            )
          }
        })
      }
    },
    decodeHtml (html) {
        var txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    },
    getPlainText (htmlString, subject) {
      if (htmlString) {
        let htmlStringPlain = htmlString.replace(/<[^>]+>/g, '').replace(/&nbsp;/g,'').slice(0, 25)
        if (htmlStringPlain === '') {
          if (htmlString.includes('<img')) {
            return this.getImageIcon()
          } else {
            return subject
          }
        } else {
          htmlStringPlain = `${htmlStringPlain}`
          if (htmlStringPlain.length <= 24) {
            return htmlStringPlain
          } else {
            return `${htmlStringPlain}...`
          }
        }
      }
      return ''
    },
    getImageIcon () {
      return '<img style="width:40px" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAAEQklEQVRoge2YS2wbVRSGvztj52k7TYjUpmqLShIhFlCxAolFV9BVsuiGDaxYswAkoKsWVGilSokaFCS2DRWEAKIEWKRIICEEK6SqQaXk4ZrEwXnaseOMPa/LYhIn8YzbsVvngfwtLN9zzp17/jn3zB0batSoUaPGQyC8jGdff/uYIgL9wBkgvLspucgguCml8u5XAxcnip0uARvJ3wLadiU9/6wIVTwz0v9BfLsxUBy1cefbnu5+gld6XqQ1srcFSKYzDI2OMT4RbZOW7ANe3u5XPOacAfZF8gCtkTCv9rzkDIST23a8BIQ3J+4XCrlIWop9XgIOFK4eKMULvzdUMw8Xvz6f8xV34Ctw4AX43kJdIQBB1oKlvMSw3TFBBdrrBc2qRCLQLFgsEQtwunWCC52jSAHnJ3v5JdlVtgDfFVCEQBEQDsCJJsHRRkFXSNDZLDjSKGjasIcDTqwqILRhC3qc93UKvN89yuH6NEfq0lzsHvWMexC+K7CdzeQAEBBRIBLwXl0VcLxJIAQgIWtD2pB0NIgdd08AjzcLJOB8+mNXeiCgOEJUBSIBONboVGhwtpdlI8KS0cLHsz0owolThP9SVFQBaS6hzb0HAho7ziMC7ZVchj8y3bx2562K5m5SvgApyS1cxTZmAFCW+zn15IfotsJczialb5W/QYWjjQrhgLN/MgbENZt8iaauBN8Cnoqo1Ktwb+5r1rTbBXtm7U/iC99w/PBZTjYrrAYloSBIKQpbwkFwqA7CQYW4JmmvE9SrgpwtSWiSVcMR3hKEjgb/O9u3gEYVsto/zCWuu3yx+Ke0hp8l1HSSQ3ViM19PVCE40bTlbFYFnSGBDeQtZ51y8C3Vtg3+mr6CbevevugVLOn26eYy47E3uB17E91cvm8i5Sa/Oc8X0fg1stq9kv51bYbY7NBOo5REE4NoepycPst0YgDJI2wAyhAQX7jxwJjZhRuk0rcK40RqlLQ2XhhntDvMp75zzbOsFAuLl5hfvIxlpfymBJRzDkgfh4uU3I32YZoZNH2G+MqwKyS+NMx6PrZjTjJ1HcOcxzQTJFNDZVXpkR9keWOFu7GPmPp3ANs2XH5bGkwlrmJv9Mva+k/k9a3f6nl9irXsz77Xq8pJvJz8jUx2uqQ/p88SX/4cw5wjnfnB5c942EpR0UnsB0MzUFUFoXg/TxOp75HGBCqmyyel21aK6r0LSYmuuR+r2/1L2UlsP711H6r6MmebNma+9N20pEUqn3yoNar+NmrkDWyr9FMlZ+bQTK3i61f/dVqCoenOlxKs5lNY0qro8r6beKT3s4oWqDYH/ke9l4A0OP9J7hcKuQhWi31uAYIfAYZGx/aFiGQ6w7Vvx5yB5Gax39UDqinPWao4PT4Rfeydvk+qn6F/VoRqnys2uiowPHjpb6GKU8AXbGynPSYNfClU+7mR/suTe51MjRo1avzP+A949qQ11PGB5gAAAABJRU5ErkJggg=="/>'
    },
    handlePageChange (list_type, page) {
      this.selected.length = 0
      if (list_type === 'inbox') {
        if (!this.inboxPageLimitSet) return
        this.query_page.inbox.current_page = page
        this.getInboxList()
      } else if (list_type === 'sent') {
        if (!this.sentPageLimitSet) return
        this.query_page.sent.current_page = page
        this.getSentList()
      } else if (list_type === 'draft') {
        if (!this.draftPageLimitSet) return
        this.query_page.draft.current_page = page
        this.getDraftList()
      }
    },
    preventCommaKey (event) {
      //
      const keyCode = event.keyCode ? event.keyCode : event.which
      if (keyCode === 44) {
        event.preventDefault()
      }
    },
    preventVSTable () {},
    selectedAll (e, email_type) {
      let select_data = []
      if (email_type === 'sent') {
        select_data = this.EmailSentData
      } else if (email_type === 'inbox') {
        select_data = this.EmailInboxData
      } else if (email_type === 'draft') {
        select_data = this.EmailDraftData
      }

      if (e.target.checked) {
        this.selected = select_data.map((id) => {
          return id.id
        })
      } else {
        setTimeout(() => {
          this.selected = []
        }, 0)
      }

      select_data = []
    },
    images_upload_handler (blobInfo, success, failure) {
      const xhr = new XMLHttpRequest()
      xhr.withCredentials = true
      xhr.open('POST', this.image_url)

      xhr.upload.onprogress = function (e) {
        progress((e.loaded / e.total) * 100)
      }

      xhr.onload = function () {
        // let json

        if (xhr.status === 403) {
          failure(`HTTP Error: ${xhr.status}`, { remove: true })
          return
        }

        if (xhr.status < 200 || xhr.status >= 300) {
          failure(`HTTP Error: ${xhr.status}`)
          return
        }

        const json = JSON.parse(xhr.responseText)

        if (!json || typeof json.location !== 'string') {
          failure(`Invalid JSON: ${xhr.responseText}`)
          return
        }

        success(json.location)
      }

      xhr.onerror = function () {
        failure(
          `Image upload failed due to a XHR Transport error. Code: ${xhr.status}`
        )
      }

      xhr.setRequestHeader(
        'Authorization',
        `Bearer ${JSON.parse(localStorage.getItem('access_token'))}`
      )

      const formData = new FormData()
      formData.append('files[0]', blobInfo.blob(), blobInfo.filename())

      xhr.send(formData)
    },
    example_image_upload_handler (blobInfo, success, failure, progress) {
      const formData = new FormData()
      formData.append('files[0]', blobInfo.blob())

      const data = this.fileupload(formData)

      data
        .then((res) => {
          const locationObject = {
            src: {
              value: {
                location: res
              }
            }
          }

          const stringify = JSON.stringify(res)
          const parse = JSON.parse(stringify)

          success(parse)
        })
        .catch((error) => {
          console.log(error)
        })
    },

    async fileupload (payload) {
      try {
        const customer_id = localStorage.getItem('customer_id')

        const responseImage = await contentFileUpload(customer_id, payload)
        const location =
          responseImage.data.data.cdn +
          responseImage.data.data.files[0].file_path
        this.$vs.notify({
          title: 'Success',
          text: 'Image Uploaded Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
        return location
      } catch (error) {
        //
      }
    },
    removeCC () {
      this.EmailHasCC = !this.EmailHasCC
      this.selected_recipient_cc = []
    },
    getAllRecipients (emailListData) {
      // eslint-disable-next-line no-unused-vars
      emailListData.forEach(function (value, key) {
        // eslint-disable-next-line no-unused-vars
        value.allRecipients = ''
        value.allRecipients_admin_staff = ''
        value.allRecipients_clients = ''
        let allRecipientsArr_admin_staff = []
        let allRecipientsArr_clients = []
        let allRecipientsArr_parent = []
        value.to_admin_or_staff_users.forEach(function (value1, key2) {
          allRecipientsArr_admin_staff = value.to_admin_or_staff_users.map(
            (value1) => {
              if (value1.user !== null) {
                return `${value1.user.first_name} ${value1.user.last_name}`
              }
            }
          )
        })
        value.to_client_users.forEach(function (value1, key2) {
          allRecipientsArr_clients = value.to_client_users.map((value1) => {
            if (value1.user !== null) {
              return `${value1.client_user.first_name} ${value1.client_user.last_name}`
            }
          })
        }) 
        
        value.to_parent_users.forEach(function (value1, key2) {
          allRecipientsArr_parent = value.to_parent_users.map((value1) => {
            if (value1.client_user !== null) {
              return `${value1.client_user.first_name} ${value1.client_user.last_name}`
            }
          })
        })

        value.allRecipients = allRecipientsArr_admin_staff
          .concat(allRecipientsArr_clients).concat(allRecipientsArr_parent)
          .join(', ')

        if (value.external_users !== null) {
          // value.isCollapseCard = false
          const allExternalUsersArr = value.external_users.map((value1) => {
            return value1.email
          })
          value.allExternalUsers = allExternalUsersArr.join(', ')
        } else {
          value.allExternalUsers = ''
        }
      })
    },
    getAllSender (emailListData) {
      // eslint-disable-next-line no-unused-vars
      emailListData.forEach(function (value, key) {
        value.sender = `${value.from_user.first_name} ${value.from_user.last_name}`
      })
    },
    //-------- Functions for fetching SENT/INBOX/DRAFT emails list START --------
    async getSentList () {
      const customer_id = localStorage.getItem('customer_id')
      const payload = {
        search: this.search
      }

      // if (this.query_page.sent.next_page_url) {
      //    this.query_page.sent.current_page = this.meta.current_page - 1
      //   } else {
      //    this.query_page.sent.current_page=this.meta.current_page
      //   }
      const data = await getEmailSentList(
        this.sorting_obj_sent,
        'email_sent',
        payload,
        customer_id,
        this.query_page.sent.current_page,
        this.sentPageLimitSet
      )
      //
      this.EmailSentData = data.data.data.emails
      // this.EmailSentData.all_external_users = this.EmailSentData.external_users.map((external_users) => {
      //   return external_users.email.join(',')
      // })
      const table = this.EmailSentData
      this.query_page.sent = data.data.data.meta
      table.map((row, index) => {
        const row_index = index + 1
        Object.assign(row, { row_index })
      })
      this.EmailSentData = table
      this.rowDataSent = this.EmailSentData

      this.getAllRecipients(this.EmailSentData)
    },
    async getInboxList () {
      const customer_id = localStorage.getItem('customer_id')
      const payload = {
        search: this.search
      }
      const data = await getEmailInboxList(
        this.sorting_obj,
        'email_inbox',
        payload,
        customer_id,
        this.query_page.inbox.current_page,
        this.inboxPageLimitSet
      )
      //
      this.EmailInboxData = data.data.data
      if (this.EmailInboxData.new_message_count === 0) {
        this.EmailInboxData_new_message_count = ''
      } else {
        this.EmailInboxData_new_message_count = `(${this.EmailInboxData.new_message_count})`
      }
      this.EmailInboxData = data.data.data.emails
      const table = this.EmailInboxData
      this.query_page.inbox = data.data.data.meta
      table.map((row, index) => {
        const row_index = index + 1
        Object.assign(row, { row_index })
      })
      this.EmailInboxData = table
      this.rowData = this.EmailInboxData

      this.getAllRecipients(this.EmailInboxData)
      this.getAllSender(this.EmailInboxData)
    },
    async getDraftList () {
      const customer_id = localStorage.getItem('customer_id')
      const payload = {
        search: this.search
      }
      const data = await getEmailDraftList(
        this.sorting_obj_draft,
        'email_draft',
        payload,
        customer_id,
        this.query_page.draft.current_page,
        this.draftPageLimitSet
      )
      //
      this.EmailDraftData = data.data.data.emails
      const table = this.EmailDraftData
      this.query_page.draft = data.data.data.meta
      table.map((row, index) => {
        const row_index = index + 1
        Object.assign(row, { row_index })
      })
      this.EmailDraftData = table
      this.rowDataDraft = this.EmailDraftData

      this.getAllRecipients(this.EmailDraftData)
    },
    //-------- Functions for fetching SENT/INBOX/DRAFT emails list END --------

    //------- Functions for deleting SENT/INBOX/DRAFT emails START -------
    async deleteInboxEmail (email_id) {
      try {
        const customer_id = localStorage.getItem('customer_id')
        const deleteEmailPayload = {
          ids: [email_id]
        }
        // eslint-disable-next-line no-unused-vars
        const data = await deleteInboxEmail(customer_id, deleteEmailPayload)
        this.$vs.notify({
          title: 'Success',
          text: 'Email deleted successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
      } catch (e) {
        this.$vs.notify({
          title: 'Error',
          text: e.data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          time: 3000
        })
      }
      this.getInboxList()
    },
    async deleteSentEmail (email_id) {
      try {
        const customer_id = localStorage.getItem('customer_id')
        const deleteEmailPayload = {
          ids: [email_id]
        }
        // eslint-disable-next-line no-unused-vars
        const data = await deleteSentEmail(customer_id, deleteEmailPayload)
        this.$vs.notify({
          title: 'Success',
          text: 'Email deleted successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
      } catch (e) {
        this.$vs.notify({
          title: 'Error',
          text: e.data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          time: 3000
        })
      }
      this.getSentList()
    },
    async deleteDraftEmail (other_ids) {
      try {
        const customer_id = localStorage.getItem('customer_id')
        const deleteEmailPayload = {
          ids: other_ids
        }
        // eslint-disable-next-line no-unused-vars
        const data = await deleteDraftEmail(customer_id, deleteEmailPayload)
        this.getDraftList()
        this.$vs.notify({
          title: 'Success',
          text: 'Email deleted successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
      } catch (e) {
        this.$vs.notify({
          title: 'Error',
          text: e.data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          time: 3000
        })
      }
    },
    //------- Functions for deleting all selected emais from all list -------
    async deleteAllSelectedEmail () {
      try {
        const customer_id = localStorage.getItem('customer_id')
        const selectedIds = []
        this.selected.forEach((ele) => {
          selectedIds.push(ele.id)
        })
        const deleteEmailPayload = {
          ids: selectedIds
        }
        // eslint-disable-next-line no-unused-vars
        const delete1 = await deleteInboxEmail(customer_id, deleteEmailPayload)
        // eslint-disable-next-line no-unused-vars
        const delete2 = await deleteSentEmail(customer_id, deleteEmailPayload)
        // eslint-disable-next-line no-unused-vars
        const delete3 = await deleteDraftEmail(customer_id, deleteEmailPayload)
        //
        this.getInboxList()
        this.getSentList()
        this.getDraftList()
        this.selected = []
        this.showPopUpBool = false
        this.$vs.notify({
          title: 'Success',
          text: 'Email deleted successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
        this.query_page.sent.current_page = this.query_page.sent.next_page_url
          ? this.query_page.sent.current_page
          : this.query_page.sent.current_page - 1
        this.query_page.inbox.current_page = this.query_page.inbox.next_page_url
          ? this.query_page.inbox.current_page
          : this.query_page.inbox.current_page - 1
        this.query_page.draft.current_page = this.query_page.draft.next_page_url
          ? this.query_page.draft.current_page
          : this.query_page.draft.current_page - 1
      } catch (e) {
        this.$vs.notify({
          title: 'Error',
          text: e.data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          time: 3000
        })
      }
    },
    //------- Functions for deleting SENT/INBOX/DRAFT emails END -------

    // async fetch_user_client_list (type) {
    //   //
    //   //

    //   try {
    //     this.$vs.loading()
    //     const customer_id = localStorage.getItem('customer_id')
    //     const data = await fetch_user_client_list(customer_id, type)
    //     //
    //     if (type === 'User') {
    //       this.recipient_user_list = data.data.data.results
    //       this.recipient_user_list_cc = data.data.data.results
    //     } else if (type === 'Client') {
    //       this.recipient_client_list = data.data.data.results
    //       this.recipient_client_list_cc = data.data.data.results
    //     }
    //   } catch (error) {
    //   } finally {
    //     this.$vs.loading.close()
    //   }
    // },
    async fetch_user_general_list (type) {
      //
      //

      try {
        this.$vs.loading()
        const customer_id = localStorage.getItem('customer_id')
        const { data } = await fetch_user_general_list(type, customer_id)
        if (type === 'User') {
          this.recipient_user_list = data.data.users_list
          this.recipient_user_list_cc = data.data.users_list
        } else if (type === 'Client') {
          this.recipient_client_list = data.data.users_list
          this.recipient_client_list_cc = data.data.users_list
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.$vs.loading.close()
      }
    },
    composeEmail () {
      //
      this.emailSidebar = true
      this.activeEditDraftId = null
      // this.selected_recipient_cc = []
    },
    openDraftEdit (draft_data) {
      this.draft_other_ids = draft_data.other_ids
      this.from_user_type = '1'
      this.emailSubject = draft_data.subject
      this.emailBody = draft_data.body
      this.emailSidebar = true
      this.activeEditDraftId = draft_data.id
      this.EmailHasCC = false
      this.user_recipient = false
      this.client_recipient = false
      this.custom_user_recipient = false
      this.selectedPlatformModule = draft_data.platform_module_id
      this.getRelatedRecords().then(() => {
        this.selectedRelatedRecords = draft_data.entity_id
      })

      //Getting all To User recipients from draft data
      this.selected_user_recipient = draft_data.other_receivers
        .map((value) => {
          if (value.is_root_user === 1) {
            if (
              this.recipient_user_list.some(
                (item) => item.user_id === value.to_user_id
              )
            ) {
              return value.to_user_id
            }
          }
        })
        .filter(Boolean)

      //Getting all To Staff recipients from draft data
      // this.selected_staff_recipient = draft_data.other_receivers.map((value) => {
      //   if (value.is_root_user === 1) {
      //     if (this.recipient_staff_list.some(item => item.users_id === value.to_user_id)) {
      //       return value.to_user_id
      //     }
      //   }
      // }).filter(Boolean)

      //Getting all To Client recipients from draft data
      this.selected_client_recipient = draft_data.other_receivers
        .map((value) => {
          if (value.is_root_user === 1 && value.to_user_type === 2) {
            return value.to_user_id
          }
        })
        .filter(Boolean)

      //Getting all CC User recipients from draft data
      this.selected_user_recipient_cc = draft_data.other_receivers
        .map((value) => {
          if (value.is_root_user === 0) {
            if (
              this.recipient_user_list_cc.some(
                (item) => item.user_id === value.to_user_id
              )
            ) {
              return value.to_user_id
            }
          }
        })
        .filter(Boolean)

      //Getting all CC Staff recipients from draft data
      // this.selected_staff_recipient_cc = draft_data.other_receivers.map((value) => {
      //   if (value.is_root_user === 0) {
      //     if (this.recipient_staff_list_cc.some(item => item.user_id === value.to_user_id)) {
      //       return value.to_user_id
      //     }
      //   }
      // }).filter(Boolean)

      //Getting all CC Client recipients from draft data
      this.selected_client_recipient_cc = draft_data.other_receivers
        .map((value) => {
          if (value.is_root_user === 0 && value.to_user_type === 2) {
            return value.to_user_id
          }
        })
        .filter(Boolean)

      //Getting all To External/ Custom Email from draft data
      this.external_users = draft_data.external_users
        .map((value) => {
          if (value.is_root_user === true) {
            return value.email
          }
        })
        .filter(Boolean)
        .join(', ')

      //Getting all CC External/ Custom Email from draft data
      this.external_users_cc = draft_data.external_users
        .map((value) => {
          if (value.is_root_user === false) {
            return value.email
          }
        })
        .filter(Boolean)
        .join(', ')

      if (
        this.selected_user_recipient.length > 0 ||
        this.selected_user_recipient_cc.length > 0
      ) {
        this.user_recipient = true
      }

      // if (this.selected_staff_recipient.length > 0 || this.selected_staff_recipient_cc.length > 0) {
      //   this.staff_recipent = true
      // }

      if (
        this.selected_client_recipient.length > 0 ||
        this.selected_client_recipient_cc.length > 0
      ) {
        this.client_recipient = true
      }

      if (
        this.selected_user_recipient_cc.length > 0 ||
        this.selected_client_recipient_cc.length > 0 ||
        this.external_users_cc !== ''
      ) {
        this.EmailHasCC = true
      }

      if (this.external_users !== '' || this.external_users_cc !== '') {
        this.custom_user_recipient = true
      }
    },
    handlcreateSidebar () {
      this.emailSidebar = false
      this.clearComposeEmail()
    },
    clearComposeEmail () {
      this.emailSubject = ''
      this.emailBody = ''
      this.selected_user_recipient = []
      this.selected_client_recipient = []
      this.selected_user_recipient_cc = []
      this.selected_client_recipient_cc = []
      this.sendEmailToUsers = []
      this.external_users = ''
      this.external_users_cc = ''
      this.external_users_arr = []
      this.custom_user_recipient = false
      this.client_recipient = false
      this.custom_user_recipient_cc = false
      this.client_recipient_cc = false
      this.selected_recipient_cc = []
      this.emailSidebar = false
      this.selectedPlatformModule = null
      this.selectedRelatedRecords = null
      this.relatedRecordList = []
      this.fieldCodes = []
    },
    getSelectedRecipientObject (selected_recipient, to_user_type, is_root_user) {
      for (let i = 0; i < selected_recipient.length; i++) {
        this.sendEmailToUsers.push({
          to_user_id: selected_recipient[i],
          to_user_type,
          is_root_user
        })
      }
    },
    getCustomEmailObject (external_user, is_root_user) {
      external_user = external_user.split(',')
      for (let i = 0; i < external_user.length; i++) {
        if (external_user[i].trim() !== '') {
          this.external_users_arr.push({
            email: external_user[i].trim(),
            is_root_user
          })
        }
      }
    },
    async sendSaveEmail (send_or_save) {
      //To Recipients
      if (this.user_recipient) {
        this.getSelectedRecipientObject(this.selected_user_recipient, 1, true)
      }
      if (this.client_recipient) {
        this.getSelectedRecipientObject(
          this.selected_client_recipient,
          2,
          true
        )
      }
      if (this.custom_user_recipient) {
        this.getCustomEmailObject(this.external_users, true)
      }

      //CC Recipients
      if (this.EmailHasCC) {
        if (this.user_recipient) {
          this.getSelectedRecipientObject(
            this.selected_user_recipient_cc,
            1,
            false
          )
        }
        if (this.client_recipient) {
          this.getSelectedRecipientObject(
            this.selected_client_recipient_cc,
            2,
            false
          )
        }
        if (this.custom_user_recipient) {
          this.getCustomEmailObject(this.external_users_cc, false)
        }
      }

      const emailPayload = {
        from_user_type: this.from_user_type,
        is_parent_thread: true,
        subject: this.emailSubject,
        body: this.emailBody,
        to_users: this.sendEmailToUsers,
        email_type: send_or_save === 'send' ? 1 : 3,
        external_users: this.external_users_arr,
        platform_module_id: this.selectedPlatformModule,
        entity_id: this.selectedRelatedRecords
      }

      //
      //

      if (
        this.sendEmailToUsers.length === 0 &&
        this.external_users_arr.length === 0
      ) {
        this.$vs.notify({
          title: 'Error',
          text: 'No Recipient Selected',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          time: 3000
        })
        return false
      } else {
        try {
          this.$vs.loading()
          const customer_id = localStorage.getItem('customer_id')
          // eslint-disable-next-line no-unused-vars
          const data = await sendSaveEmail(customer_id, emailPayload)
          //
          this.getSentList()
          this.getDraftList()

          this.$vs.notify({
            title: 'Success',
            text:
              send_or_save === 'send'
                ? 'Email Sent Successfully'
                : 'Email saved as draft',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success',
            time: 3000
          })
          this.clearComposeEmail()

          if (this.activeEditDraftId !== null) {
            try {
              const deleteEmailPayload = {
                ids: this.draft_other_ids
              }
              const data = await deleteDraftEmail(
                customer_id,
                deleteEmailPayload
              )
              console.log(data)
              this.activeEditDraftId = null
              this.draft_other_ids = null
              this.getDraftList()
            } catch (e) {
              //console.log(e)
            }
          }
        } catch (error) {
          let errorText = error.data.errors
          if (error.data.errors.body) {
            errorText = 'Body is required'
          } else if (error.data.errors.to_users) {
            errorText = 'To users is required'
          } else if (error.data.errors.subject) {
            if (
              error.data.errors.subject[0] ===
              'The subject may not be greater than 255 characters.'
            ) {
              errorText = error.data.errors.subject[0]
            } else {
              errorText = 'Subject is required'
            }
          }

          //If there is any error empty selected users and custom emails
          this.external_users_arr = []
          this.sendEmailToUsers = []

          this.$vs.notify({
            title: 'Error',
            text: errorText,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            time: 3000
          })
        } finally {
          this.$vs.loading.close()
        }
      }
    },
    openEmailDetailsPage (details_page_type, event) {
      //setTimeout(function(){
      //
      this.selected = []
      const email_id = event.id
      this.$router.push({
        name: 'Email_Details',
        params: { email_id, details_page_type }
      })
      //})
    },
    appendCodeToTemplate (field_code) {
      // eslint-disable-next-line no-undef
      tinymce.activeEditor.execCommand('mceInsertContent', false, field_code)
      // this.templateData.template += ` ${field_code}`
      this.$vs.notify({
        title: 'Success',
        text: 'Code added',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success',
        time: 2000
      })
    }
  },
  mounted () {
    this.gridApi = this.inboxGridOptions.api
    this.getRepositoryDetails()

    // this.fetch_user_client_list('User')
    // this.fetch_user_client_list('Client')

    this.fetch_user_general_list('User')
    this.fetch_user_general_list('Client')

    //this.getSentList()
    //this.getInboxList()
    //this.getDraftList()

    // if (this.$route.query.client_id) {
    //   this.selected_client_recipient.push(Number(this.$route.query.client_id))
    //   this.user_recipient = false
    //   this.client_recipient = true
    //   this.composeEmail()
    // } else if (this.$route.query.user_id) {
    //   this.selected_user_recipient.push(Number(this.$route.query.user_id))
    //   this.user_recipient = true
    //   this.client_recipient = false
    //   this.composeEmail()
    // }
    if (this.$route.query.related_id) {
      this.openEmailDetailsPage('inbox', this.$route.query.related_id)
    }
  },
  watch: {
    inboxPageLimitSet () {
      this.handlePageChange('inbox', 1)
    },
    draftPageLimitSet () {
      this.handlePageChange('draft', 1)
    },
    sentPageLimitSet () {
      this.handlePageChange('sent', 1)
    },
    tabIndex () {
      if (this.tabIndex === 0) {
        this.gridApi = this.inboxGridOptions.api
        this.search = ''
      } else if (this.tabIndex === 1) {
        this.gridApi = this.sentGridOptions.api
        this.search = ''
      } else if (this.tabIndex === 2) {
        this.gridApi = this.draftGridOptions.api
        this.search = ''
      }
    },
    from_user_type () {
      // if (value === 3) {
      //   this.custom_emails = true
      //
      // } else {
      //   this.fetch_user_client_list()
      // }
    }
  },
  beforeRouteLeave (to, from, next) {
    this.emailSidebar = false
    setTimeout(() => {
      next()
    }, 0)
  }
}
</script>

<style>
.vuesax-app-is-ltr .vs-sidebar.vs-sidebar-position-right {
  z-index: 1000;
}
.unread {
  background-color: #fff5ec;
  font-weight: 500;
}
.new {
  background-color: transparent !important;
  font-weight: 500;
}
.email-table tr {
  box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.2);
  position: relative;
}
.email-table tr:hover .delete-btn {
  display: block;
  top: 0;
}
.email-card {
  position: relative;
}
.compose-btn,
.delete-all-btn {
  position: absolute;
  right: 10px;
  top: 10px;
  /* background: #FF9F43 !important; */
  /* box-shadow: 0 8px 25px -8px rgba(255, 159, 67, 1) !important; */
}
.delete-all-btn {
  right: 100px;
}
.delete-btn {
  display: none;
  position: absolute;
  /* top: 10px; */
  right: 30px;
  padding: 0 10px;
}
.delete-btn:hover {
  background: #e9eaea;
  border-radius: 50%;
}
.delete-btn .feather-icon {
  margin: 8px 0;
}
.delete-btn svg {
  width: 18px;
  color: #727373;
}
.email-sidebar .vs-sidebar {
  max-width: 400px;
  margin-top: 107px;
}
.email-sidebar .sidebar-scrollable-form {
  height: calc(100% - 175px);
  overflow-y: auto;
  overflow-x: hidden;
}
.email-form input,
.email-form input:focus {
  border: none !important;
  box-shadow: none;
}
.sub-line {
  border: none !important;
  height: 40px;
}
.email-action-btns {
  text-align: right;
}
.compose-btns {
  display: inline;
  margin-right: 15px;
}
.email-cc {
  margin-top: 15px;
}
.selectCheckBox {
  width: 5px;
}

@media (max-width: 360px) {
  .email-sidebar .vs-sidebar {
    max-width: 100%;
  }
}
</style>